import { PropsOf } from '@codeleap/types'
import { View, ActivityIndicator, List } from '@/components'

export type ScrollProps = PropsOf<typeof List> & {
  renderItem: (info: { item: any; index: number; isLast?: boolean }) => React.ReactNode
}

export function Scroll({ renderItem, ListEmptyComponent, threshold = 10, ...props }: ScrollProps) {
  const isEmpty = !props?.data || props.data.length === 0
  return (
    <View
      // @ts-ignore
      style={['column', { overflowY: 'auto', width: '100%', ...props?.style?.wrapper }]}
      onScroll={e => {
        if (!props.hasNextPage || props?.isFetchingNextPage || props?.isFetching) return
        onScrollToBottom(e, props.fetchNextPage, threshold)
      }}>
      {props?.ListHeaderComponent?.()}
      {isEmpty && ListEmptyComponent ? (
        ListEmptyComponent({})
      ) : (
        <View style={['column', 'fullWidth']} >
          {props?.data?.map((item, index) => renderItem({ item, index }))}
        </View>
      )}

      {props.isFetchingNextPage && (
        <View style={['justifyCenter']}>
          <ActivityIndicator debugName='CourseList:Loading' />
        </View>)
      }
    </View>
  )
}

export const onScrollToBottom = (scrollEvent, onEndReached = () => { }, threshold) => {
  const { scrollTop, clientHeight, scrollHeight } = scrollEvent.target

  const atBottom = scrollTop + clientHeight >= scrollHeight - threshold

  if (atBottom) {
    onEndReached?.()
  }
}
